import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../_metronic/helpers'
import { getValueFromResource } from '../../common/timeLiveFunction'
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { GetAccountEmployeeProjectsWithoutAllocations, ShowAssignmentModal } from './SchedulerSlice';
import { ShowToast } from '../../common/Toastr';

const AddProjectModal = ({ onClose }: any) => {
    const { employeeId } = useAppSelector((state) => state.scheduler);
    const [projectData, setProjectData] = useState([]);
    const [selectedProject, setSelectedProject] = useState<number | null>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('')
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const selectProject = (item: any) => {
        if (!item?.IsProjectManager) {
            ShowToast('Warning', "You do not have permission to access this project", "warning", "toast-top-right");
            return;
        }
        setSelectedProject(item?.AccountProjectId);
        dispatch(ShowAssignmentModal({ flag: true, ShowAssignmentModal: { ...employeeId, HoursPerDay: item?.HoursPerDay, ProjectId: item?.AccountProjectId, name: item?.ProjectName, subtitle: item?.ClientName, AccountEmployeeId: employeeId?.AccountEmployeeId, employeeName: employeeId?.parentName, clickedDate: new Date() } }));
        onClose();
    };

    const getProjectsWithOutAllocation = async () => {
        try {
            const response = await dispatch(GetAccountEmployeeProjectsWithoutAllocations(employeeId?.AccountEmployeeId));
            const result = response?.payload;
            setProjectData(result);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (employeeId?.AccountEmployeeId) {
            getProjectsWithOutAllocation();
        }
    }, [])

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm)
        }, 300)

        return () => {
            clearTimeout(handler)
        }
    }, [searchTerm])

    const onHandleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
    }

    const filteredProjects = projectData.filter((item: any) =>
        item?.ProjectName?.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
        item?.ClientName?.toLowerCase().includes(debouncedSearch.toLowerCase())
    )

    return (
        <div className="card-body">
            <div className="modal drawer-overlay" style={{ display: 'block' }}>
                <div className="modal-dialog" style={{ maxWidth: '450px' }}>
                    <div className="modal-content" style={{ maxHeight: '50vh' }}>
                        <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem' }}>
                            <h5 className="modal-title mainHeading">{getValueFromResource('Select Project', dispatch, t)}</h5>
                            <div className="btn btn-icon btn-sm btn-active-secondary" onClick={onClose}>
                                <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                            </div>
                        </div>
                        <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }}>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={onHandleSearch}
                                    placeholder={getValueFromResource('Search', dispatch, t)}
                                    className="form-control h-35px fs-7 fw-normal pr-4"
                                    data-kt-user-table-filter="search"
                                />
                                <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>
                            <div className="mt-3">
                                {filteredProjects?.length > 0 && filteredProjects.map((item: any) => (
                                    <div
                                        key={item.AccountProjectId}
                                        onClick={() => selectProject(item)}
                                        className="d-flex flex-column justify-content-center px-2 py-2 cursor"
                                        style={{
                                            borderBottom: '1px solid #eff2f5'
                                        }}
                                    >
                                        <span
                                            className="text-dark"
                                            style={{ fontWeight: 550 }}
                                        >
                                            {item?.ProjectName}
                                        </span>

                                        <span
                                            style={{ color: '#7b8ba6', fontSize: 11 }}
                                        >
                                            {item?.ClientName}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            {filteredProjects.length === 0 &&
                                <div className=''>
                                    <p className='noDataFound'>
                                        {getValueFromResource('No Record Found', dispatch, t)}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AddProjectModal